import { CONSTANTS } from '../attributes/LocatorAlerts';
import FilterTranslatorConverter from '../../attributes/filters/FilterTranslatorConverter';
import Util from '../Util';

/**
 * filterTranslator returns an object that looks like this:
 * {
 * [CONSTANTS.POSITION_PENDING] : () => {
    return {
      type : 'equals',
      field : `data/locatorAlerts@/[${CONSTANTS.POSITION_PENDING}]`,
      value : true
    }
   },
 * }
 * 
 */

// check locator for all alerts within locatorAlerts
let filterTranslator = Object.fromEntries(Object.values(CONSTANTS).map(key => [key, () => ({
  type: 'exists',
  field: `data/locatorAlerts@/[${key}]`
})]));
const specialFilters = {
  [CONSTANTS.NOT_REPORTING]: () => {
    return Util.notReportingLocatorsFilter();
  }
};
filterTranslator = {
  ...filterTranslator,
  ...specialFilters
};
export default FilterTranslatorConverter.create('locator.alerts', filterTranslator);